module.exports = __webpack_public_path__ + "static/img/banner-井下智能防爆终端.4f584c2c.webp";